import { MessageType, MessageStatus } from '@gig/magic-sdk/dist/adapter/messages/message';

/**
 * Checks if a message is older than 2 days
 * @param message
 */
function isHidden(message) {
    if (isResponsibleGamingAlert(message)) {
        return false;
    }
    if (message.once && message.status === MessageStatus.DELETED) {
        return true;
    }
    {
        return (new Date().valueOf() - new Date(message.sentAt).valueOf() >
            172800000);
    }
}
/**
 * Checks if the message is a responsible gaming alert.
 * @param message The message to check
 */
function isResponsibleGamingAlert(message) {
    return message.type === MessageType.ALERTS;
}

export { isHidden, isResponsibleGamingAlert };
